import http from '@/http.js';
import eventBus from '@/eventBus.js';
import store from "@/store";
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useAjoutRequete({emit}) {
    const idRequete = ref('');
    const schemas = ref([]);
    const schema = ref({ idSchema: 1 });
    const titre = ref('');
    const type = ref(1);
    const description = ref('');
    const sql = ref('');
    const gravite = ref(1);
    const tables = ref('');
    const message = ref('');
    const keywords = ref('');
    const champAnomalique = ref('');
    const optionType = ref([
        { value: "1", text: "requête" },
        { value: "2", text: "script php" },
    ]);
    const optionGravite = ref([
        { value: "1", text: "Bloquant" },
        { value: "2", text: "Majeur" },
        { value: "3", text: "Mineur" },
    ]);
    const requeteData = ref({});
    const toastMessage = ref("");
    const showNotification = ref(false);
    const toastType = ref("info");
    const duration = ref(5000);

    const invalid = yup.object({
        titre: yup.string().required('Ce champ est obligatoire'),
        description: yup.string().required('Ce champ est obligatoire'),
        sql: yup.string().required('Ce champ est obligatoire')
    });

    const { handleSubmit } = useForm({
        validationSchema: invalid
    });

    const fetchSchemas = async () => {
        schemas.value = await http.getSchema();
    };

    const handleInsertRequete = handleSubmit(async (values) => {
        requeteData.value = {
            idRequete: idRequete.value,
            idUtilisateur: store.state.idUtilisateur,
            titre: values.titre,
            type: type.value,
            description: values.description,
            sql: values.sql,
            gravite: gravite.value,
            tables: tables.value,
            message: message.value,
            keywords: keywords.value,
            champAnomalique: champAnomalique.value,
            schema: schema.value,
        };

        try {
            const data = await http.insertRequete(requeteData.value);
            idRequete.value = data;
            emit('close');
            eventBus.emit('reloadRequetes');
            emit('notification', {
                showNotification: true,
                toastMessage: "La requête a été ajoutée avec succès!",
                toastType: "success",
            });
        } catch (error) {
            emit('notification', {
                showNotification: true,
                toastMessage: 'Erreur lors de l\'ajout de la requete.',
                toastType: "danger",
            });
        }
    });

    onMounted(() => {
        fetchSchemas();
        eventBus.on('insertRequete', handleInsertRequete);
    });

    onBeforeUnmount(() => {
        eventBus.off('insertRequete', handleInsertRequete);
    });

    const emitInsertRequete = () => {
        eventBus.emit('insertRequete');
    };

    return {
        idRequete,
        titre,
        schema,
        schemas,
        type,
        description,
        sql,
        gravite,
        tables,
        message,
        keywords,
        optionType,
        champAnomalique,
        optionGravite,
        emitInsertRequete,
        toastMessage,
        showNotification,
        toastType,
        duration
    };
}